module.exports = __webpack_public_path__ + "img/DKFT11189.0b41314b.png";